<template>
  <!-- :fill-height="!$vuetify.breakpoint.xsOnly" fluid fill-height-->
 <v-container  fluid >
            <!-- <div id="checkout">Billing</div> -->
          
<!-- <stripe-pricing-table pricing-table-id="prctbl_1SChvgAXAFZfMq9NNkJu5Ixq"
publishable-key="pk_test_51Nn1nlAXAFZfMq9NdFPD4Cignl0WpECylmPArkIZdUyPIcTGslmJRgvXPSkQfaooK43d2oXkyol1HHolnXsXu2uU00fI8sGL19">
</stripe-pricing-table> -->

<div v-if="showbilling">
<v-row class="ml-4 mr-4" justify="center" v-bind:style="{ align:'center'}">
      <v-col align="left" justify="center"  cols="12" xl="12" lg="12" md="12" sm="12" xs="12">
       <h1 class="display-6 fw-bold lh-1 mb-3" v-bind:style="{ fontSize:'38px',color:'#215295' }">
            {{this.lg_header_feature.manage_billing}}
          </h1>
           <h5 class="display-6 fw-bold lh-1 mb-3" v-bind:style="{ fontSize:'16px',fontWeight:'300 !important' }">
            {{this.lg_header_feature.manage_billing_details}}
          </h5>
      </v-col>
    </v-row>

<v-row align="top" justify="center" class=""> 
        <!-- plan free -->
      <v-col  cols="12" sm="12" md="4">  
        <v-card  class="mx-6 mx-md-0 hover-zoom card-outter pa-4 content-card" elevation="2" style="border-radius:30px;" >
          <v-card-text align="center" justify="center">
            <v-row>
              <!-- <v-col justify="center" align="center" cols="1">
             </v-col> -->
           <v-col justify="center" align="left" cols="12">
            <h3 v-bind:style="{ fontWeight:'600 !important',color:'#000000' }"  class="nav-label black--text"> <v-icon color="green" size="18">mdi-checkbox-marked-circle</v-icon> {{ this.lg_header_feature.pricesubtitlefree }}</h3> 
             </v-col>
        </v-row>

        <!-- textIndent: '-30px',paddingLeft: '40px' บรรทัดที่2 จะขยับไปขวา -->
          <v-row class="mt-2">
           <v-col justify="center" align="left" cols="12" v-bind:style="{ fontSize:'14px',fontWeight:'500 !important',color:'#000000' }">
            <v-icon color="black" size="small">mdi-circle</v-icon> {{ this.lg_header_feature.titlefreeplandetails1 }}
        </v-col>
        </v-row>
          <v-row class="mt-n6">
           <v-col justify="center" align="left" cols="12" v-bind:style="{ fontSize:'14px',fontWeight:'500 !important',color:'#000000' }">
            <v-icon color="black" size="small">mdi-circle</v-icon> {{ this.lg_header_feature.titlefreeplandetails2 }}
        </v-col>
        </v-row>
          <v-row class="mt-n6">
           <v-col justify="center" align="left" cols="12" v-bind:style="{ fontSize:'14px',fontWeight:'500 !important',color:'#000000' }">
            <v-icon color="black" size="small">mdi-circle</v-icon> {{ this.lg_header_feature.titlefreeplandetails3 }}
        </v-col>
        </v-row>

          </v-card-text>
        </v-card>
      </v-col>

 <!-- plan pro -->
      <v-col  cols="12" sm="12" md="4" >
        <v-card outlined class="mx-6 mx-md-0 hover-zoom card-outter pa-4 content-card" elevation="2" style="border-radius:30px;" >
          <v-card-text align="center" justify="center">
            <v-row>
           <v-col justify="center" align="left" cols="5">
            <h3 v-bind:style="{ fontWeight:'600 !important',color:'#000000' }" class="nav-label black--text">{{ this.lg_header_feature.titleproplan }}</h3> 
             </v-col>
              <v-col justify="center" align="right" cols="7">
            <h3 v-bind:style="{ fontWeight:'600 !important',color:'#000000' }" class="nav-label black--text">฿ 390 {{ this.lg_header_feature.subtitlefree }}</h3> 
             </v-col>
        </v-row>

          <v-row class="mt-2">
           <v-col justify="center" align="left" cols="12" v-bind:style="{ fontSize:'14px',fontWeight:'500 !important',color:'#000000' }">
            <v-icon color="black" size="small">mdi-circle</v-icon> {{ this.lg_header_feature.titleproplanoptions1 }}
        </v-col>
        </v-row>
          <v-row class="mt-n6">
           <v-col justify="center" align="left" cols="12" v-bind:style="{ fontSize:'14px',fontWeight:'500 !important',color:'#000000' }">
            <v-icon color="black" size="small">mdi-circle</v-icon> {{ this.lg_header_feature.titleproplanoptions2 }}
        </v-col>
        </v-row>
          <v-row class="mt-n6">
           <v-col justify="center" align="left" cols="12" v-bind:style="{ fontSize:'14px',fontWeight:'500 !important',color:'#000000' }">
            <v-icon color="black" size="small">mdi-circle</v-icon> {{ this.lg_header_feature.titleproplanoptions3 }}
        </v-col>
        </v-row>
                  <v-row class="mt-n6">
           <v-col justify="center" align="left" cols="12" v-bind:style="{ fontSize:'14px',fontWeight:'500 !important',color:'#000000' }">
            <v-icon color="black" size="small">mdi-circle</v-icon> {{ this.lg_header_feature.titleproplanoptions4 }}
        </v-col>
        </v-row>

          <v-row class="mt-12" justify="center" align="center">
        <v-card-actions class="card-actions">
         <v-row>
           <v-col justify="center" align="center" cols="12" class="py-6">
           <v-btn
           @click="PaycheckoutPro('pro')"
                 elevation="2"
               v-bind:style="{ fontSize:'14px',fontWeight:'600 !important',backgroundColor:'#215295',color:'#ffffff' }"
                height="35"
                width="100%"
              >
              {{ this.lg_header_feature.upgrade_now }}
              </v-btn>
        </v-col>
        </v-row>
        </v-card-actions>
        </v-row>
          </v-card-text>
        </v-card>
      </v-col>


       <!-- plan business -->
      <v-col  cols="12" sm="12" md="4">
        <v-card  class="mx-6 mx-md-0 hover-zoom card-outter relative-card pa-4 content-card" elevation="2" style="border-radius:30px;" >
           <!-- <v-icon
    class="icon-top-right"
    color="#215295"
    size="40"
  >
    mdi-star-circle
  </v-icon> -->
          <v-card-text align="center" justify="center">
            <v-row>
           <v-col justify="center"  align="left" cols="5">
            <h3 v-bind:style="{ fontWeight:'600 !important',color:'#000000' }" class="nav-label black--text">{{ this.lg_header_feature.titlebusinessplan }}</h3> 
             </v-col>
                           <v-col justify="center" align="right" cols="7">
            <h3 v-bind:style="{ fontWeight:'600 !important',color:'#000000' }" class="nav-label black--text">฿ 990 {{ this.lg_header_feature.subtitlefree }}</h3> 
             </v-col>
        </v-row>

          <v-row class="mt-2">
           <v-col justify="center" align="left" cols="12" v-bind:style="{ fontSize:'14px',fontWeight:'500 !important',color:'#000000' }">
            <v-icon color="black" size="small">mdi-circle</v-icon> {{ this.lg_header_feature.titlebusinessplanoptions1 }}
        </v-col>
        </v-row>
          <v-row class="mt-n6">
           <v-col justify="center" align="left" cols="12" v-bind:style="{ fontSize:'14px',fontWeight:'500 !important',color:'#000000' }">
            <v-icon color="black" size="small">mdi-circle</v-icon> {{ this.lg_header_feature.titlebusinessplanoptions2 }}
        </v-col>
        </v-row>
          <v-row class="mt-n6">
           <v-col justify="center" align="left" cols="12" v-bind:style="{ fontSize:'14px',fontWeight:'500 !important',color:'#000000' }">
            <v-icon color="black" size="small">mdi-circle</v-icon> {{ this.lg_header_feature.titlebusinessplanoptions3 }}
        </v-col>
        </v-row>
                  <v-row class="mt-n6">
           <v-col justify="center" align="left" cols="12" v-bind:style="{ fontSize:'14px',fontWeight:'500 !important',color:'#000000' }">
            <v-icon color="black" size="small">mdi-circle</v-icon> {{ this.lg_header_feature.titlebusinessplanoptions4 }}
        </v-col>
        </v-row>

        <v-row class="mt-12" justify="center" align="center">
          <v-card-actions class="card-actions">
         <v-row>
           <v-col justify="center" align="center" cols="12" class="py-6">
           <v-btn
            @click="PaycheckoutPro('business')"
                 elevation="2"
                v-bind:style="{ fontSize:'14px',fontWeight:'600 !important',backgroundColor:'#215295',color:'#ffffff' }"
                height="35"
                width="100%"
              >
              {{ this.lg_header_feature.upgrade_now }}
              </v-btn>
        </v-col>
        </v-row>
        </v-card-actions>
        </v-row>
          </v-card-text>
        </v-card>
      </v-col>

       <!-- plan custom -->
      <!-- <v-col  cols="12" sm="6" md="3">
        <v-card color="#215295" class="mx-6 mx-md-0 hover-zoom card-outter" elevation="4" style="border-radius:30px;border:2px solid #215295;" >
          <v-card-text align="center" justify="center">
            <v-row>
           <v-col justify="center" align="center" cols="12">
            <h3 v-bind:style="{ fontSize:'16px',fontWeight:'600 !important',color:'#ffffff' }">{{ this.lg_header_feature.titlecusstomplan }}</h3> 
             </v-col>
        </v-row>

          <v-row>
           <v-col justify="center" align="center" cols="12">
            <h3 v-bind:style="{ fontSize:'24px',fontWeight:'600 !important',color:'#ffffff' }">{{ this.lg_header_feature.title_custom }}</h3> 
          </v-col>
        </v-row>

         <v-row>
           <v-col justify="center" align="center" cols="12">
            <h3 v-bind:style="{ fontSize:'18px',fontWeight:'600 !important',color:'#ffffff' }">{{ this.lg_header_feature.subtitlefree }}</h3> 
         </v-col>
        </v-row>

            <v-divider class="mt-2" color="#ffffff" style="border-top:1px solid #ffffff;"></v-divider>

             <v-row class="mt-2">
           <v-col justify="center" align="center" cols="12">
           <v-btn
                class="rounded-pill"
                v-bind:style="{ fontSize:'14px',fontWeight:'600 !important',color:'#000000' }"
                 height="30"
              >
              {{ this.lg_header_feature.explore_features }}
              </v-btn>
        </v-col>
        </v-row>

          <v-row class="mt-2">
           <v-col justify="center" align="left" cols="12" v-bind:style="{ fontSize:'16px',fontWeight:'500 !important',color:'#ffffff' }">
            <v-icon color="white">mdi-checkbox-marked-circle</v-icon> {{ this.lg_header_feature.titlecusstomplanoptions1 }}
        </v-col>
        </v-row>
          <v-row >
           <v-col justify="center" align="left" cols="12" v-bind:style="{ fontSize:'16px',fontWeight:'500 !important',color:'#ffffff' }">
            <v-icon color="white">mdi-checkbox-marked-circle</v-icon> {{ this.lg_header_feature.titlecusstomplanoptions2 }}
        </v-col>
        </v-row>
          <v-row >
           <v-col justify="center" align="left" cols="12" v-bind:style="{ fontSize:'16px',fontWeight:'500 !important',color:'#ffffff' }">
            <v-icon color="white">mdi-checkbox-marked-circle</v-icon> {{ this.lg_header_feature.titlecusstomplanoptions3 }}
        </v-col>
        </v-row>

         <v-row class="mt-2" justify="center" align="center">
        <v-card-actions class="card-actions">
         <v-row>
           <v-col justify="center" align="center" cols="12">
           <v-btn
                 elevation="2"
                v-bind:style="{ fontSize:'14px',fontWeight:'600 !important',color:'#000000' }"
                height="35"
                width="150"
                  @click="onClickMenu('/contact')"
              >
              {{ this.lg_header_feature.buttonpro }}
              </v-btn>
        </v-col>
        </v-row>
        </v-card-actions>
        </v-row>
          </v-card-text>
        </v-card>
      </v-col> -->
    </v-row>
    </div>
      <LoadingDialog></LoadingDialog>
</v-container>
</template>

<script>
import api from "@/services/api";
import { server } from "../services/constants.js";
import { feature } from "../services/constants.js";
import LoadingDialog from "@/components/cards/LoadingDialog";
import { lg_header_feature } from "./language/lg_header_feature.js";

export default {
  name: "Contact",
  data: () => ({
    showbilling:false,
    clientSecret: null,
    stripe:null,
    showpop: false,
    dateNow: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .replace("T", " ")
      .substr(0, 16),
    margincardpriceplans: "mx-auto ml-0 mt-0 mr-0 mb-0",
    width: 420,
    width_emp: 600,
    text_fontsize: 30,
    privacy_sta: "false",
    privacyDlg: false,
  }),
  components: {
      LoadingDialog,
    },
   async beforeCreate() {
      this.$store.state.page_reload = false;

       localStorage.getItem(feature.LANGUAGE) === "th"
        ? this.lg_header_feature = lg_header_feature.lg_header_feature_th
        : this.lg_header_feature = lg_header_feature.lg_header_feature_en;
    },
    async mounted() {
      const userId = localStorage.getItem(server.USER_ID);
       if (userId && !api.isLoggedIn()) {
      this.$router.push("/listroom");
      return;
    }

    try {
         await this.loadbilling();
    } catch (err) {
      console.error("Stripe init error:", err);
        this.$swal.fire("Error", err, "error");
        this.$router.back();
        // this.$router.push("/pricing");
    }

    
    },
    computed: {
  buttonsmall() {
     if(this.$vuetify.breakpoint.name === "xs"){
       return true;
     }
      },
    widthbutton() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "75%";
        case "sm":
          return "76%";
        case "md":
          return "60%";
        case "lg":
          return "40%";
        case "xl":
          return "40%";
      }
    },
    widthheightimage(){
 switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "300";
        case "sm":
          return "400";
        case "md":
          return "400";
        case "lg":
          return "400";
        case "xl":
          return "400";
      }
      },
    },
    methods: {
      async loadbilling(){
         this.$store.state.loadMenu = true;
    
    //  const stripe = await loadStripe('pk_test_51Nn1nlAXAFZfMq9NdFPD4Cignl0WpECylmPArkIZdUyPIcTGslmJRgvXPSkQfaooK43d2oXkyol1HHolnXsXu2uU00fI8sGL19');
   const checkemil =  await api.checkemailstripepayment({email:localStorage.getItem(server.USERNAME)});
    if(checkemil.data && checkemil.data.customer_email){
     const result =  await api.billingportalstripepayment({email:localStorage.getItem(server.USERNAME)});
     if(result.data.portal){
      window.location.href = `${result.data.portal.url}`;

//  let win;
//  win = window.open(
//         `${result.data.portal.url}`,
//         "_blank"
//       );
//        if (win && !win.closed) {
//         // console.log("✅ New tab opened successfully");
//       } else {
//         // console.warn("❌ Failed to open new tab (possibly blocked by popup blocker)");
//       }
     this.$store.state.loadMenu = false;
      // this.onClickMenu("/listroom");
      
      return;
     }else if(result.data.canceled && result.data.canceled == true){
       this.showbilling = true;
      this.$store.state.loadMenu = false;
      return;

     }else{
      
          this.$store.state.loadMenu = false;
    this.onClickMenu("/listroom");
     }
      
     return;

    }else{
      this.showbilling = true;

//         const result = await api.billingportalstripepaymentloginnobilling({email:localStorage.getItem(server.USERNAME)});
//          console.log("billingportalstripepaymentloginnobilling")
//         console.log(result.data)
//              if(result.data.portal_session){
//  let win;
//  win = window.open(
//         `${result.data.portal_session.url}`,
//         "_blank"
//       );
//        if (win && !win.closed) {
//         // console.log("✅ New tab opened successfully");
//       } else {
//         // console.warn("❌ Failed to open new tab (possibly blocked by popup blocker)");
//       }
//      this.$store.state.loadMenu = false;
//       this.onClickMenu("/listroom");
      
//       return;
//      }else{
//           this.$store.state.loadMenu = false;
//     this.onClickMenu("/listroom");
//      }
//  this.onClickMenu("/checkout-session");
    this.$store.state.loadMenu = false;
      }
      
        this.$store.state.loadMenu = false;
      },
       async PaycheckoutPro(plan_name){
    localStorage.setItem(feature.GET_BUY_NOW, `${plan_name}`);
     this.$router.push(`/checkout-session`);
     return;
  },
      onClickMenu(link) {
      // console.log(link);
      this.$router.push(link).catch((err) => {});
    },
    },
};
</script>


<style scoped>
.textinform{
  width:75%;
}
@media (max-width: 599px) {
  .joinmeeting-container {
    margin-top:-150px;
  }
  .v-main {
    margin-top:-50px;
    height: 110% !important;
  }
}
@media (max-width: 959px) {
  .joinmeeting-container {
    margin-top:-180px !important;
  }
}

@media (min-width: 1260px) {
  .joinmeeting-container {
    margin-top: 5rem;
  }
  
}

.v-main {
    max-width: 100%;
    height: 100%;
    width: 100%;
    background-image: linear-gradient(to right bottom, #b3c8ee, #b2c9f0, #b1c9f3, #b0caf5, #afcbf8) !important;
}
.joinmeeting-container {
    margin-top: -10px;
  }

  .homepricing_paragraph{
  transform: translateY(16px);
  opacity: 0;
  transition: 2s ease;
}
.homepricing_paragraph--visible{
  transform: translateY(0);
  opacity: 1;
}

.hover-zoom:hover {
  transform: scale(1.07);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  cursor: pointer;
}
.relative-card {
  position: relative;
}

.icon-top-right {
   position: absolute;
  top:-16px; 
  right:16px; 
  background: white;
  cursor: pointer;
  z-index: 10; 
}
.card-outter {
  padding-bottom:50px;
}
.card-actions {
  position: absolute;
  bottom: 0;
  justify-self: center;
}
table tr > th {
  border:2px solid #dddddd;
  text-align-last: center;
  /* background: lightgray; */
}
table tr > td:first-child {
  border:2px solid #dddddd;
  background: lightgray;
  text-align-last: center;
}
table tr > td {
  border:2px solid #dddddd;
  text-align-last: center;
  /* background: lightgray; */
}
 table {
      width: 100%;
      border-collapse: collapse;
      box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    }

    thead th {
      background-color: #e0efff;
      color: #000;
      font-size: 18px;
      padding: 16px;
      text-align: center;
      border: 1px solid #ccc;
    }

    thead th:nth-child(2) { background-color: #cfe5ff; }
    thead th:nth-child(3) { background-color: #a9cdfd; }
    thead th:nth-child(4) { background-color: #5F98D9; }
    thead th:nth-child(5) { background-color: #3173B5; color: #000000; }

    tbody td {
      padding: 12px;
      text-align: center;
      border: 1px solid #ddd;
      font-size: 15px;
    }

    tbody td:first-child {
      text-align: left;
      background-color: #f8f8f8;
      font-weight: bold;
    }

    .check {
      color: green;
      /* font-size: 16px; */
    }

    .cross {
      color: red;
      font-size: 16px;
    }

    /* Responsive styles */
    @media (max-width: 768px) {
      table, thead, tbody, th, td, tr {
        display: block;
      }

      thead {
        display: none;
      }

      tbody tr {
        margin-bottom: 16px;
        border: 1px solid #ccc;
        border-radius: 10px;
        overflow: hidden;
        background-color: #fff;
        padding: 10px;
      }

      tbody td {
        text-align: right;
        position: relative;
        padding-left: 50%;
        border: none;
        border-bottom: 1px solid #eee;
      }

      tbody td:first-child {
        background-color: #f0f0f0;
        font-weight: bold;
        text-align: left;
        padding-left: 10px;
        border-bottom: none;
      }

      tbody td::before {
        content: attr(data-label);
        position: absolute;
        left: 10px;
        width: 45%;
        padding-left: 10px;
        font-weight: bold;
        text-align: left;
        white-space: nowrap;
      }
    }
    .sidebar-nav-item.active .v-icon,
.sidebar-nav-item.active .nav-label {
  color: #1a56db !important;
}

.nav-label {
  font-size: 0.88rem;
  font-weight: 500;
}
.content-card {
  background: #ffffff;
  border: 1px solid #e8eaf0;
}
</style>
